$( document ).ready(function() {

    console.log('qwerty');
  
	var seen = localStorage.getItem('mc');
 	if(seen === null) {
 		$('.mc-overlay').addClass('visible');
 	};

	 $('#mc-submit').on('click', function(e) {
	 	e.preventDefault();
	 	localStorage.setItem('mc', 'true');
	 	$('#mc-signup').submit();
	 });


	$('.mc-form-close').on('click', function() {
		$('.mc-overlay').fadeOut();
		localStorage.setItem('mc', 'true');
	});

	$('.home-slideshow').slick({
		dots: false,
		infinite: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		cssEase:'linear',
		arrows: false,
		autospeed: 0,
		speed: 2000,
		focusOnSelect: false,
		autoplaySpeed: 0,
		autoplay: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
		],
	});

	if (document.getElementById('blog-container')) {

		var limit = 240;
		var zoom = 1;
		var progress = 0;
		var distance = 0;
		var opacity = 1;
		var text_opacity = 1;

		$("a[href='#top']").click(function() {
			$("html, body").animate({ scrollTop: 0 }, "300");
			return false;
		});

		$(document).on("scrollstart",onScroll)
		// $(document.body).on('touchmove', onScroll); // for mobile
		$(window).on('scroll', onScroll);

		function onScroll() {

			var scrolltop = $(window).scrollTop();

			progress = scrolltop/limit;
			zoom = Math.min(1+progress, 1.3);
			distance = 250*progress;
			opacity = 2 - zoom;
			text_opacity = 1 - progress;

			$("#blog-title h1").css('opacity', text_opacity);

			$('.swiper-slide-active img').css({'transform': 'scale(' + zoom + ')'});

			$('.swiper-slide-prev img').css({'transform': 'translateX(-' + distance + 'px)'});
			$('.swiper-slide-prev h2').css({'transform': 'translateX(-' + distance + 'px)'});

			$('.swiper-slide-next img').css({'transform': 'translateX(' + distance + 'px)'});
			$('.swiper-slide-next h2').css({'transform': 'translateX(' + distance + 'px)'});

			$('.swiper-slide-prev img').css('opacity', opacity);
			$('.swiper-slide-next img').css('opacity', opacity);

			var active_post = $('.swiper-slide-active').data('handle');

			var w = $(window).width();

			if(progress > 0) {
				$('.swiper-button-next-custom').hide();
				$('.swiper-button-prev-custom').hide();
			} else {
				$('.swiper-button-next-custom').show();
				$('.swiper-button-prev-custom').show();
			}

			if(progress < 0.05) {
				$(".blog-content-article").fadeOut();
			} else {
				$('.blog-content-article[data-handle="'+active_post+'"]').fadeIn();
			}

		}

	}

	$('.swiper-button-prev-custom').mouseover(function() {
		$('.swiper-slide-prev').find('img').addClass('hover');
  })

  .mouseout(function() {
		$('.swiper-slide-prev').find('img').removeClass('hover');
  });

	$('.swiper-button-next-custom').mouseover(function() {
		$('.swiper-slide-next').find('img').addClass('hover');
  })
  .mouseout(function() {
		$('.swiper-slide-next').find('img').removeClass('hover');
  });

 // quote slider
  $('.quote-container').slick({
    autoplay: true,
    fade: true,
    pauseOnHover: false,
    dots: false,
    prevArrow: false,
    nextArrow: false
  });

	// add info icon to subscription radio label on product page
  $('.rc_label.rc_label__autodeliver').append('<svg version="1.1" class="sub-info" class="hvr-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 97.4 97.4" style="enable-background:new 0 0 97.4 97.4;" xml:space="preserve"><style type="text/css">.st0{fill:#1D1D1B;}</style><g><path class="st0" d="M48.7,0C21.9,0,0,21.9,0,48.7c0,26.9,21.9,48.7,48.7,48.7c26.9,0,48.7-21.9,48.7-48.7C97.4,21.9,75.6,0,48.7,0z M48.7,92.9c-24.4,0-44.2-19.8-44.2-44.2c0-24.4,19.8-44.2,44.2-44.2c24.4,0,44.2,19.8,44.2,44.2C92.9,73.1,73.1,92.9,48.7,92.9z"/><rect x="45.6" y="38.9" class="st0" width="6.2" height="37"/><path class="st0" d="M48.7,23.9c-2.6,0-4.6,2.1-4.6,4.7c0,2.6,2,4.6,4.6,4.6c2.6,0,4.6-2,4.6-4.6C53.3,25.9,51.3,23.9,48.7,23.9z"/></g></svg>');


	$(document).foundation();

  $('#video').click(function(){
  	$('video').get(0).play();
  });

  $('.age-gate').hide();

	// var ofage = localStorage.getItem('agegate');
	// // console.log('ofage', ofage);
	// if(!ofage) {
	// 	$('.age-gate').addClass('open');
	// }

	// $('.agree-agegate').click(function(e) {
	// 	e.preventDefault();
	// 	localStorage.setItem('agegate', true);
	// 	$('.age-gate').toggleClass('open');
	// });

  var pDesc = $("#product-description").height();

  // $("blockquote").css('height', pDesc);
  $("#subscription-overlay").css('height', '100%');
	$(".subscription-overlay").css('height', '100%');

  	$('.accordion').on({
		    'up.zf.accordion': function(){
				//console.log('up');
				$('accordion-content').removeClass("down");

			}
		});

		$('.accordion').on({
		    'down.zf.accordion': function(){
				//console.log('down');
				setTimeout(function(){
					$('accordion-content').addClass("down");
					//$('html,body').animate({scrollTop: $('.is-active').offset().top - 0}, 'slow');
				}, 500);
			}
		});

  	//External links

  	var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
          links[i].target = '_blank';
      }
    }


  	$("#reload").click(function() {
			setTimeout(() => {
				location.reload();
			}, 1000);
    });

  	// Variants


  	$(function (){
      	var option = $(".selector-wrapper:nth-of-type(1) select");
      	var flavour = $(".selector-wrapper:nth-of-type(2)");

      	//$(".selector-wrapper:nth-of-type(2) select").val(val).trigger('change');

        if ( $(option).val() === "12 cans"){
          	//console.log("hide");
			flavour.hide();
        }

      	else {
        	option.show();
      	}
	});

  	$( ".selector-wrapper select" ).change(function() {

      	var option = $(".selector-wrapper:nth-of-type(2)");
      	var val = $(".selector-wrapper:nth-of-type(2) select option").val();

        if ($(this).val() === "12 cans"){
			$(".selector-wrapper:nth-of-type(2) select").val(val).trigger('change');
					option.hide();
        }

      	else {
        	option.show();
      	}
	});

  	// Hide Recharge bits

  	var subs = $('#rc_subscription_id').css('display');
  	if (subs == 'none' || subs == 'none!important') {
  		$('#rc_container').css('display', 'none');
    }

  	//Basket

  	var cartCount = $('.cart-count').text();
    var cartNum = parseInt(cartCount);

    //console.log(cartNum);

    if ( (cartNum > 0 ) && (cartNum < 2 ) ) {

      //console.log ("fill 1");
      if ( $('#basket').hasClass('fill-1') ) {
      }

      else {
      	$('#basket').addClass('fill-1');
        $('#basket').removeClass('fill-2');
      }
   	}

    else if ( (cartNum >= 2) ) {
      //console.log ("fill 2");
      if ( $('#basket').hasClass('fill-2') ) {
      }

      else {
      	$('#basket').addClass('fill-2');
        $('#basket').removeClass('fill-1');
      }
    }

    else {
    	//console.log ("remove");
      	$('#basket').removeClass('fill-1');
      	$('#basket').removeClass('fill-2');
    }

  //Basket AJAX

  $(document).ajaxComplete(function() {

    var cartCount = jQuery('.cart-count').text();
    var cartNum = parseInt(cartCount);

    //console.log(cartNum);

    if ( (cartNum > 0 ) && (cartNum < 2 ) ) {

      //console.log ("fill 1");
      if ( $('#basket').hasClass('fill-1') ) {
      }

      else {
      	$('#basket').addClass('fill-1');
        $('#basket').removeClass('fill-2');
      }
   	}

    else if ( (cartNum >= 2) ) {
      //console.log ("fill 2");
      if ( $('#basket').hasClass('fill-2') ) {
      }

      else {
      	$('#basket').addClass('fill-2');
        $('#basket').removeClass('fill-1');
      }
    }

    else {
    	//console.log ("remove");
      	$('#basket').removeClass('fill-1');
      	$('#basket').removeClass('fill-2');
    }
  });

  // Homepage

  var click = false;
  var logo = false;
  var basket = false;

  var cursor = 'body, .main-content, #container, #header, #footer, #hamburger, #basket, #logomark, #menu,  a'

//    $(cursor).on('mousedown', function() {
//      $(this).css('cursor', 'default');
//    });

//   $(cursor).on('mouseup', function() {
//      $(this).css('cursor', 'default');
//    });


 $('.toggle-product-info').click(function() {
		$(this).parent().parent().find('blockquote').toggleClass('open');
         console.log('toggle block quote');
  });

$('.toggle-product-info2').click(function() {
		$(this).closest('.seltzer-us').find('.subscription-overlay').toggleClass('open');
});


//   $('.toggle-product-info').click(function() {
// 		$(this).parent().find('blockquote').toggleClass('open');
// 	});

// 	$('.toggle-product-info2').click(function() {
// 		$('.product-info #subscription-overlay').toggleClass('open');
// 	});

	// $('#info').click(function() {
	// 	console.log("click");
	// 	$(this).find('blockquote').toggleClass('open');
	// });

  // $('#info').click (function() {
	// 	console.log('aa');
  // 	$('.product-info blockquote').toggleClass('open');
  // });

//   $('.sub-info').click(function() {
//   	$('.subscription-overlay').toggleClass('open');
//   });


$(document).on('click','.sub-info',function(){
//   $('.sub-info').click (function() {
  	$('.subscription-overlay').toggleClass('open');
  });

//   $('#video').click (function() {
//   	$('#story').toggleClass('open');
//   });

// screensaver

var timeout = null;
var imgCount = 0;
var screensaver = false;

$(document).on('mousemove', function() {

	if (timeout !== null) {
        $('#screensaver').css("display", "none");
        clearInterval(timeout);
  }

	timeout = setTimeout(function() {

		console.log("timer");

			var imgCount = 0;

			var allCount = $('.ss').length;

			$('#screensaver').css("display", "block");

			let timerId = setTimeout(function tick() {

					var ssImg = $( '.ss:eq(' + imgCount + ') ');
					var getURL = $(ssImg).attr("pre");
					$(ssImg).attr("src", getURL);

					if ( $(document).width() < 640 ) {

							var rX = Math.floor(Math.random() * 650) + -150;
							var rY = Math.floor(Math.random() * 750) + -150;
							var imgHeight = Math.floor(Math.random() * 75) + 150;

					} else {

						var rX = Math.floor(Math.random() * 1640) + -200;
						var rY = Math.floor(Math.random() * 968) + -268;
						var imgHeight = Math.floor(Math.random() * 200) + 300;

					}

					var resize = $(ssImg).css({'height' : imgHeight});


					var imgWidth = $(resize).width();

					//$(ssImg).css({'height' : 'auto', 'width' : 'auto'});

					var position = $(resize).css({'top' : rY, 'left' : rX, 'width' : 'auto' });

					$(position).show();

					imgCount ++;

					$(document).on('mousemove', function() {
						imgCount = 200;
						$(position).hide();

						//console.log(imgCount);
					});

					if ( imgCount > allCount ) {
							setTimeout(() => { clearInterval(timerId); console.log('stop'); }, 0);
					}

					timerId = setTimeout(tick, 2000); // (*)

			}, 1000);
	}, 120000);

});

  //image hide & count
  $('.home').hide();

  var count = 0;
  var count_elements = $('.home').length;

  //show first img

  var img = $( '.home:eq(' + count + ') ');

  var color = $(img).attr('color');

  if ( $(document).width() < 640 ) {

    var randomX = Math.floor(Math.random() * 600) + -150;
		var randomY = Math.floor(Math.random() * 750) + -150;
  	var height = 200

  } else {

    var randomX = Math.floor(Math.random() * 1640) + -200;
  	var randomY = Math.floor(Math.random() * 968) + -268;
    var height = 400

  }

  var resize = $(img).css({'height' : height});

  var width = $(resize).width();

  var centerY = height / 2;

  var centerX = width / 2;

  //var position = $(resize).css({'top' : verticalCenter - centerY, 'left' : horizontalCenter - centerX})

  var position = $(resize).css({'top' : randomY, 'left' : randomX})

  setTimeout(function(){
  	$('#container').css({'background' : color});
  	$(position).show();
  }, 1500 );

  count++;

	var startX;
	var startY;
	var delta = 6;

	$('.home-gallery-image').on('mousedown', function(e) {
		startX = e.pageX;
		startY = e.pageY;
	})

	$('.home-gallery-image').on('mouseup', function(e) {
		var diffX = Math.abs(e.pageX - startX);
		var diffY = Math.abs(e.pageY - startY);

		if (diffX < delta && diffY < delta) {
			window.location = '/blogs/articles'
		}

	})

  //Drag
  //
  $( ".home" ).draggable({
  	start: function( event, ui ) {},
  	stop: function( event, ui ) {}
  });

  $( ".home-gallery-image" ).draggable({
  	start: function( event, ui ) {},
  	stop: function( event, ui ) {}
  });


  //Reveal

  $("#basket").click (function() {
    $("#menu").removeClass("open");
    $("#hamburger").removeClass("open");
  });

  $("#hamburger").on('click', function() {
    console.log('burger click');
    $("#menu").toggleClass("open");
    $("#hamburger").toggleClass("open");
    $("body").toggleClass("open");
    console.log("Hamburger clicked, menu should toggle"); // Add debugging
  });

  $(".icon-cart, .icon-x, #CartDrawer, input").on('mousedown', function() {
    $('.product-info blockquote').removeClass('open');
  	if ( basket == true ) {
		//console.log(basket);
  	} else {
			basket = true;
  	}
  });

  $("#logomark").on('mousedown', function() {
  	logo = true;
  });

  $( document ).mousedown(function() {
  	$( ".home" ).on( "dragstart", function( event, ui ) {
  		$('#container').addClass("dragged");
  		$('#container').css('cursor', 'grabbing');
  	});
  });

  $( document ).mouseup(function() {

  		// $('#drag').css('cursor', 'pointer');

  	if ( $('#container').hasClass("dragged") ) {
  		//console.log('just dragged');
  		$('#container').removeClass("dragged")
  	}

  	else if ( click == true ) {
  		click = false;
  		//console.log(click);
  	}

  	else if ( logo == true ) {
  		logo = false;
  		//console.log(logo);
  	}

    else if ( basket == true ) {
  		basket = false;
  	}

  	else {

  		//var left = parseInt($('#drag').css("left"));
  		//var top = parseInt($('#drag').css("top"));
  		//var xPos = event.pageX - left;
  		//var yPos = event.pageY - top;

      var xPos = event.pageX;
  		var yPos = event.clientY;
  		var img = $( '.home:eq(' + count + ') ');
  		var color = $(img).attr('color');

  		count++;

  		if (count > count_elements ) {
  			$("#container").css({'background' : "#fff"});
  			// $('.home').hide();
  			count = 0;
  		}

  		else {

				if ( $(document).width() < 768 ) {
					var height = Math.floor(Math.random() * 200) + 150
				}
				else  {
					var height = Math.floor(Math.random() * 200) + 300
				}

				var resize = $(img).css({'height' : height});
				var width = $(resize).width();
				var centerY = height / 2;
				var centerX = width / 2;
				var position = $(resize).css({'top' : yPos - centerY, 'left' : xPos - centerX})
				$('#container').css({'background' : color});
				// $(position).show();

  		}
  	}

  });



  $(document).keyup(function(e) {
  	if (e.key === "Escape") {
  		if ( $("#menu").hasClass("open") ) {
  			$("#menu").toggleClass("open");

  		}

  		else if ( $(".product-info blockquote").hasClass("open") ) {
  			$(".product-info blockquote").toggleClass("open");

  		}

  		else {
  			$("#container").css({'background' : "#fff"});
  			// $('.home').hide();
  			count = 0;
  		}
  	}
  });

console.log("Script loaded successfully");
  
});//End Doc Ready
